export default class Watcher {
  constructor (interval) {
    this.interval = interval;
    this.watcher = null;
  }

  clear = function () {
    if (this.watcher !== null) {
      clearTimeout(this.watcher);
      this.watcher = null;
    }
  }

  init (callback = () => {}) {
    this.clear();
    if (typeof callback === 'function') {
      callback();
    }

    this.watcher = setTimeout(() => {
      this.init(callback);
    }, this.interval);
  }
}
